import React from "react";
import { Link } from "react-router-dom";
import Layout from "./Layout";
import "../styles/legal.css";

/**
 * Обёртка для юридических страниц (Политика конфиденциальности,
 * Пользовательское соглашение). Шапка документа + переключатель между
 * документами + контент.
 *
 * props:
 *   title      — заголовок документа
 *   subtitle   — подзаголовок (краткое описание + дата редакции)
 *   active     — "privacy" | "terms" — какой пункт меню подсветить
 *   children   — тело документа (h2/p/ul из legal.css)
 */
export default function LegalPage({ title, subtitle, active, children }) {
  return (
    <Layout>
      <div className="rb-legal">
        <div className="rb-container">
          <nav className="rb-legal__nav">
            <Link
              to="/terms"
              className={`rb-legal__nav-link ${
                active === "terms" ? "is-active" : ""
              }`}
            >
              Пользовательское соглашение
            </Link>
            <Link
              to="/privacy-policy"
              className={`rb-legal__nav-link ${
                active === "privacy" ? "is-active" : ""
              }`}
            >
              Политика конфиденциальности
            </Link>
          </nav>

          <header className="rb-legal__header">
            <h1 className="rb-legal__title">{title}</h1>
            {subtitle && <p className="rb-legal__subtitle">{subtitle}</p>}
          </header>

          <article className="rb-legal__doc">{children}</article>
        </div>
      </div>
    </Layout>
  );
}
